import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=08370b1c&scoped=true&"
import script from "./UserDetail.vue?vue&type=script&lang=js&"
export * from "./UserDetail.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/user-detail.scss?vue&type=style&index=0&id=08370b1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08370b1c",
  null
  
)

export default component.exports